import { Box, Grid, Stack } from '@mui/material'
import { ReactComponent as ScanIcon } from 'assets/icons/scan.svg'
import OkIcon from 'assets/okVerifyIcon'
import CustomTextField from 'components/shared/textFields/CustomTextField'
import {
	ChangeIdentificationProps,
	useChangeIdentification,
} from 'hook/mutations/useChangeIdentification'
import { IIdentificationData, ShiftOptions } from 'models/ICattlesData'
import { useEffect, useState } from 'react'
import { changeIdentifiedCowsQty } from 'store/cattlesSlice'
import { useAppDispatch } from 'store/hooks'
import { COLORS } from 'styles/colors'
import { OutlinedButton } from 'ui/buttons/OutlinedButton'
import { CardStandart } from 'ui/CardStandart'
import Preloader from 'ui/Preloader'
import { TypographyPrimary14Bold } from 'ui/typography/TypographyPrimary14Bold'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'
import { IdentificationState } from '../../DigitizationPage'
import SameTagWarningCard from '../../shared/SameTagWarningCard'
import { PAGE_SIZE } from '../table/TableBody'

interface CardIdentificationProps
	extends IIdentificationData,
		IdentificationState {
	index: number
	queryKey: ChangeIdentificationProps
	setState: React.Dispatch<
		React.SetStateAction<{
			gate: number[]
			date: number
			shift: ShiftOptions
			isDirty: boolean
		}>
	>
}

export const CardIdentification = (props: CardIdentificationProps) => {
	const [tagId, setTagId] = useState<string>(props.tag_id)

	useEffect(() => {
		setTagId(props.tag_id)
	}, [props.tag_id])

	const dispatch = useAppDispatch()
	const {
		mutate: changeIdentification,
		isPending,
		isSuccess,
		error,
	} = useChangeIdentification(props.queryKey)

	const isDigitized = props?.manually_identified

	const isIdentify = props.tag_id && props.tag_id !== '-'
	const isDisabled = isSuccess || tagId === '-' || !tagId
	const isDuplicate = error?.response?.data?.type === 'duplicate_tracking'
	return (
		<Box>
			<CardStandart sx={{ padding: '24px' }}>
				<Grid
					container
					sx={{
						display: 'grid',
						height: '100%',
						gridTemplateColumns: 'repeat(3, 1fr) 150px',
						gap: '24px',
						alignItems: 'start',
						width: '100%',
					}}
				>
					<Grid item sx={{ alignSelf: 'center' }}>
						<Stack direction={'row'} gap={'24px'}>
							<TypographySecondary14>{props.index}</TypographySecondary14>
							<TypographySecondary14
								sx={{ color: isIdentify ? COLORS.icon : COLORS.error }}
							>
								{isIdentify ? 'Оцифрована' : 'Требуется оцифровка'}
							</TypographySecondary14>
						</Stack>
					</Grid>
					<Grid item sx={{ alignSelf: 'center' }}>
						{isDuplicate ? (
							<SameTagWarningCard
								title={'Повтор номера бирки'}
								description={(() => {
									const index = parseInt(
										error?.response?.data?.payload.index,
										10,
									)
									const fieldNumber = index + 1
									const pageNumber = Math.ceil(fieldNumber / PAGE_SIZE)
									return `Указанный номер был введен ранее в поле № ${fieldNumber} (стр ${pageNumber})`
								})()}
							/>
						) : (
							<TypographyPrimary14Bold
								sx={{
									color:
										isSuccess || props.initial_cow_tag !== props.tag_id
											? COLORS.icon
											: COLORS.black,
									textDecoration:
										isSuccess || props.initial_cow_tag !== props.tag_id
											? 'line-through'
											: 'none',
								}}
							>
								{props.initial_cow_tag || '-'}
							</TypographyPrimary14Bold>
						)}
					</Grid>
					<Grid item>
						<CustomTextField
							label='Номер ушной бирки'
							value={tagId}
							width={'100%'}
							fontWeight={600}
							endAdornment={<ScanIcon />}
							isIdentification={false}
							withLabel={tagId ? true : false}
							error={isDuplicate}
							helperText={
								isDuplicate && 'Корова с таким номером уже существует'
							}
							onChange={e => {
								props.setState(prevState => ({
									...prevState,
									isDirty: true,
								}))
								setTagId(e.target.value)
							}}
						/>
					</Grid>
					<Grid item sx={{ alignSelf: 'center' }}>
						<OutlinedButton
							disabled={isDisabled || isPending || isDigitized}
							width={'100%'}
							height={'54px'}
							onClick={() => {
								const payload = {
									tracking_id: props.id,
									body: {
										cow_id: props.cow_id,
										tag_id: tagId,
										rec_date: props.date,
										camera_id: props.gate[0],
										day_period: props.shift || props.day_period,
									},
									date: props.date,
									gate: props.gate,
									shift: props.shift,
									cow_id: props.cow_id,
								}
								changeIdentification(payload, {
									onSuccess: data => {
										props.setState(prevState => ({
											...prevState,
											isDirty: false,
										}))
										dispatch(changeIdentifiedCowsQty(data.identified_cows))
									},
								})
							}}
						>
							{isPending ? (
								<Preloader size={24} />
							) : isSuccess || isDigitized ? (
								<OkIcon width='24px' height='24px' />
							) : isIdentify && !props.manually_identified ? (
								'Подтвердить'
							) : (
								'Сохранить'
							)}
						</OutlinedButton>
					</Grid>
				</Grid>
			</CardStandart>
		</Box>
	)
}
